export const toBRL = (value) => {
    const formattedValue = addThousandSeparator(value);
    return `R$ ${formattedValue}`;
};

export const addThousandSeparator = (value, decimalCases = 2) => {
    return value
        .toFixed(decimalCases)
        .replace('.', ',')
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
};